import styled, { css } from 'styled-components';

const LoadModelButton = () => css`

    ${({ theme }) => (
        theme == 'vivaTheme' &&
        `
        position: absolute;
        height:60px;
        width:100%;
        @media only screen and (max-height: 500px) {
        max-height: 35px;
        max-width: 190px;
        };
        @media (max-height: 500px) {
        font-size:11.5px;
        }
        `
    ) ||
        theme != 'vivaTheme' &&
        `
        left:-50%;
        position: relative;
        height:40px;
        width:110px;
        `
    }

    
    text-align:center;
    font-family: SharpSansBold;
    font-style: normal;
    font-weight: bold;
    color: #0A083A;
    font-size:14px;
    display:flex;
    align-items:center;
    justify-content:center;

    background: #D8E6F0;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
    background: #cfdde8;
    }
`;


export default styled.div([LoadModelButton]);